import { Injectable } from '@angular/core';
import { HttpHandler, HttpEvent, HttpErrorResponse, HttpRequest, HttpResponse, HttpInterceptor } from '@angular/common/http';

import { Observable ,  throwError as _throw } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { BlockUiService } from './block-ui.service';

/**
 * THis interceptor powers the UI-block component; it counts HTTP calls.
 */
@Injectable()
export class BasicBlockInterceptor implements HttpInterceptor {

// #region [ Constructor ]

	/**
	 * Constructor for the BasicBlockInterceptor.
	 */
	constructor(private _BlockUiService: BlockUiService) { }

// #region [ Implemented Methods ]

	/**
	 * Intercepts HTTP calls and increments a counter on the BlockUiService instance.
	 *
	 * @param request The HTTP reqeust.
	 * @param next The observable stream.
	 */
	public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const guidPattern: RegExp = new RegExp(/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/);
		const exportPattern: RegExp = new RegExp(/\bexport\b/);
		// Do not show spinner for export shipments polling calls
		if (!(guidPattern.test(request.url) && exportPattern.test(request.url))) {
			this._BlockUiService.IncrementCount();
		}
		return next
			.handle(request)
			.pipe(
				tap((event: HttpEvent<any>) => {
					if (event instanceof HttpResponse) {
						// Do not decrement count for export shipments polling calls
						if (!(guidPattern.test(event.url) && exportPattern.test(event.url))) {
							this._BlockUiService.DecrementCount();
						}
					}
				}),
				catchError((response: HttpEvent<any>) => {
					if (response instanceof HttpErrorResponse) {
						this._BlockUiService.ClearCounter();
					}
					return _throw(response);
				})
			);

	}

}